import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../../AuthContext";
import { API_BASE_URL } from "../../config";
import Header from "../Header";

export default function Creditdetail() {
  const { id } = useParams();
  const { logout } = useAuth();
  const [name, setname] = useState("");
  const [total_deposit, settotal_deposit] = useState("0");
  const [total_credit, settotal_credit] = useState("0");
  const [remaining_balance, setremaining_balance] = useState("0");
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  const [credentials] = useState({
    token: localStorage.getItem("authToken"),
    customer_id: id,
  });

  const fetchfirstdata = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/creditdetail`,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        setProducts(response.data.data);
        setname(response.data.name);
        settotal_deposit(response.data.total_deposit);
        settotal_credit(response.data.total_credit);
        setremaining_balance(response.data.remaining_balance);
      } else {
        logout();
        navigate("/");
      }
    } catch (err) {
      logout();
      navigate("/");
    }
  };

  useEffect(() => {
    const authState = localStorage.getItem("authToken");
    if (authState) {
      fetchfirstdata();
    }
  }, []);

  return (
    <>
      <Header />
      <div className="du-detils">
        <div className="container">
          <div className="product-form">
            <div className="row">
              <div className="col-md-4 col-12  wi-33p">
                <label>Name : {name}</label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12  wi-33p">
                <label>Deposit Total : {total_deposit}</label>
              </div>
              <div className="col-md-4 col-12  wi-33p">
                <label>Credit Total : {total_credit} </label>
              </div>
              <div className="col-md-4 col-12  wi-33p">
                <label>Total : {remaining_balance}</label>
              </div>
            </div>
          </div>
          <div className="show-detils">
            {products.length > 0 ? (
              <table className="table table-dark table-striped">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Debit</th>
                    <th>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((entry, i) => (
                    <tr key={i}>
                      <td>{entry.date}</td>
                      <td>{entry.amount_debit}</td>
                      <td>{entry.amount_credit}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No records found</p>
            )}
          </div>
        </div>
      </div>
      <Header />
    </>
  );
}
